import { createRoot } from 'react-dom/client'
// Axios
import axios from 'axios'
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// Apps
import { MetronicI18nProvider } from './_theme/i18n/Metronici18n'
import './_theme/assets/sass/style.react.scss'
import './_theme/assets/fonticon/fonticon.css'
import './_theme/assets/keenicons/duotone/style.css'
import './_theme/assets/keenicons/outline/style.css'
import './_theme/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_theme/assets/css/style.rtl.css'
 **/
import './_theme/assets/sass/style.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider, setupAxios } from './app/modules/auth'

import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill-new/dist/quill.snow.css';
import { envConfig } from './utils/config'
import { AiAssistantProvider } from './_theme/context/AiAssistantContext'
import { SnackbarProvider } from './_theme/context/SnackbarContext'


/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
const secret_level = window.CookieUtils.getCookie("secret_level", { secret: envConfig.APP_API_SECRET, secret_level: "none" });
window.CookieUtils.setMode((secret_level ? secret_level : envConfig.APP_API_ENCRYPTION) as any);
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
      <MetronicI18nProvider>
        <AiAssistantProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AiAssistantProvider>
      </MetronicI18nProvider>
      </SnackbarProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
